import AdminLayout from "./Components/Layouts/AdminLayout";
import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import AdminDashboard from "./Components/Admin/AdminDashboard/AdminDashboard";
import ResetPassword from "./Components/ResetPassword/ResetPassword";
// PATIENT MANAGEMENT
import AddFamily from "./Components/Admin/PatientManagement/AddFamily/AddFamily";
import AddFamilyMember from "./Components/Admin/PatientManagement/AddFamilyMember/AddFamilyMember";
import ChangePatientData from "./Components/Admin/PatientManagement/ChangePatientData/ChangePatientData";
import CheckupHistory from "./Components/Admin/PatientManagement/CheckupHistory/CheckupHistory";
import DetailPatient from "./Components/Admin/PatientManagement/DetailPatient/DetailPatient";
import PatientManagement from "./Components/Admin/PatientManagement/PatientManagement/PatientManagement";
import UpdateFamily from "./Components/Admin/PatientManagement/UpdateFamily/UpdateFamily";

import UpcomingSchedule from "./Components/Admin/PatientManagement/UpcomingSchedule/UpcomingSchedule";
import DetailQueue from "./Components/Admin/QueueManagement/DetailQueue/DetailQueue";
import MakeQueue from "./Components/Admin/QueueManagement/MakeQueue/MakeQueue";
import QueueManagement from "./Components/Admin/QueueManagement/QueueManagement";
import DetailActiveQueue from "./Components/Admin/Queues/DetailActiveQueue/DetailActiveQueue";
import QueueFrontPage from "./Components/Admin/Queues/QueueFrontPage/QueueFrontPage";
import AddUser from "./Components/Admin/UserManagement/AddUser/AddUser";
import UpdateUser from "./Components/Admin/UserManagement/UpdateUser/UpdateUser";
import UserManagement from "./Components/Admin/UserManagement/UserManagement";

// VACCINATION SCHEDULE
import SetSchedule from "./Components/Admin/VaccinationSchedule/SetSchedule/SetSchedule";
import UpdateVaccinationSchedule from "./Components/Admin/VaccinationSchedule/UpdateVaccination/UpdateVaccination";
import VaccinationSchedule from "./Components/Admin/VaccinationSchedule/VaccinationSchedule";

// VACCINES
import AddVaccine from "./Components/Admin/MasterData/VaccineList/AddVaccine/AddVaccine";
import EditVaccine from "./Components/Admin/MasterData/VaccineList/EditVaccine/EditVaccine";
import VaccinList from "./Components/Admin/MasterData/VaccineList/VaccineList/VaccineList";

// VACCINE TYPES
import AddVaccineType from "./Components/Admin/MasterData/VaccineTypes/AddVaccineType/AddVaccineType";
// import EditVaccineType from "./Components/Admin/MasterData/VaccineTypes/EditVaccineType/EditVaccineType";
import VaccineTypes from "./Components/Admin/MasterData/VaccineTypes/VaccineTypesList/VaccineTypes";

// SCHEDULE
import AddShift from "./Components/Admin/MasterData/OpenSchedule/AddShift/AddShift";
import OpenSchedule from "./Components/Admin/MasterData/OpenSchedule/OpenSchedule";
import UpdateSchedule from "./Components/Admin/MasterData/OpenSchedule/UpdateSchedule/UpdateSchedule";

import AddDate from "./Components/Admin/MasterData/BlockedDates/AddBlockedDates/AddDate";
import BlockedDates from "./Components/Admin/MasterData/BlockedDates/BlockedDates";
import UpdateDate from "./Components/Admin/MasterData/BlockedDates/UpdateBlockedDates/UpdateDate";
import QrCode from "./Components/Admin/QrCode/QrCode";

// NOTIFICATION
import Broadcast from "./Components/Admin/Notification/Broadcast/Broadcast";
import Context from "./Components/Admin/Notification/Context/Context";

// QUEUES
import AddQueue from "./Components/Admin/Queues/AddQueue/AddQueue";
import Queues from "./Components/Admin/Queues/Queues";
import Checkup from "./Components/Suster/Checkup/Checkup";
import PatientDetail from "./Components/Suster/PatientDetail/PatientDetail";
import PatientMeasure from "./Components/Suster/PatientMeasure/PatientMeasure";
import Vaccination from "./Components/Suster/Vaccination/Vaccination";

import PatientNote from "./Components/Suster/PatientNote/PatientNote";
// VISIT
import CreateVisit from "./Components/Admin/Visit/CreateVisit/CreateVisit";
import UpdateVisit from "./Components/Admin/Visit/UpdateVisit/UpdateVisit";
import Visits from "./Components/Admin/Visit/Visits/Visits";
import PatientVisit from "./Components/Suster/PatientVisit/PatientVisit";
import UpdatePatientVisit from "./Components/Suster/PatientVisit/UpdateVisit";
import FrontPage from "./Components/Suster/SetSchedule/FrontPage/FrontPage";
import EditVaccinationData from "./Components/Suster/Vaccination/EditDataVaccination/EditVaccination";

import Notifications from "./Components/Admin/Notification/Notifications/Notifications";
import ShowQueue from "./Components/Admin/Queues/ShowQueue/ShowQueue";

import SimpleReactLightbox from "simple-react-lightbox";
import "./App.css";
import { DetailRequestCertificate } from "./Components/Admin/DetailRequestCertificate/DetailRequestCertificate";
import { DuplicateData } from "./Components/Admin/DuplicateData/DuplicateData";
import AddBankAccount from "./Components/Admin/MasterData/BankAccounts/AddBankAccount/AddBankAccount";
import BankAccounts from "./Components/Admin/MasterData/BankAccounts/BankAccounts";
import EditBankAccount from "./Components/Admin/MasterData/BankAccounts/EditBankAccount/EditBankAccount";
import EditTerms from "./Components/Admin/MasterData/TermsAndConditions/EditTermsAndCondition/EditTerms";
import TermsConditions from "./Components/Admin/MasterData/TermsAndConditions/TermsConditions";
import DetailQueueConsult from "./Components/Admin/QueueManagement/DetailQueueConsult/DetailQueueConsult";
import MakeQueueConsult from "./Components/Admin/QueueManagement/MakeQueueConsult/MakeQueueConsult";
import QueueConsultOnline from "./Components/Admin/QueueManagement/QueueConsultOnline";
import DetailActiveQueueConsult from "./Components/Admin/Queues/DetailActiveQueue/DetailActiveQueueConsult";
import QueueFrontPageConsult from "./Components/Admin/Queues/QueueFrontPageConsult/QueueFrontPageConsult";
import QueuesConsult from "./Components/Admin/Queues/QueuesConsult";
import { RequestCertificate } from "./Components/Admin/RequestCertificate/RequestCertificate";
import RunningQueue from "./Components/RunningQueue/RunningQueue";
import { SelfCheckin } from "./Components/SelfCheckin/SelfCheckin";
import AddUpcomingVaccination from "./Components/Suster/UpcomingSchedule/AddUpcomingSchedule/AddVaccination";
import AddUpcomingVisit from "./Components/Suster/UpcomingSchedule/AddUpcomingSchedule/AddVisit";
import EditUpcomingVaccination from "./Components/Suster/UpcomingSchedule/EditUpcomingVaccination";
import PracticingDoctor from "./Pages/Admin/QueueManagement/PracticingDoctor/PracticingDoctor";
import OnlineConsultation from "./Pages/Admin/QueueManagement/OnlineConsultation/OnlineConsultation";
import AddEditVaccineType from "./Pages/Admin/MasterData/AddEditVaccineType/AddEditVaccineType";
import Queue from "./Pages/Admin/QueueManagement/Queue";
import Configuration from "@Pages/Admin/MasterData/Configuration/Configuration";
import OtpLoginPasien from "./Components/Admin/MasterData/OtpLoginPasien/OtpLoginPasien";


// Every admin page, in one place. This used to be a list of <AdminRoute>
// entries where EACH ONE individually wrapped its own fresh <AdminLayout>
// instance - meaning the whole sidebar (including Ant Design's Sider and its
// `collapsed` state) got unmounted and remounted from scratch on every single
// admin-to-admin navigation, replaying Ant Design's width-transition
// animation each time. A screenshot taken mid-transition showed a visible
// step/notch between the (plain, non-animated) logo header and the (CSS
// width-transitioned) menu list below it, because they were mid-animation at
// different rates.
//
// Now a single <AdminLayout> wraps a nested <Switch> of all admin routes, so
// the sidebar mounts once and stays mounted as the inner route changes - no
// more remount, no more transition replay, no more notch.
const ADMIN_ROUTES = [
  { path: "/admin-dashboard", component: AdminDashboard },

  // PATIENT MANAGEMENT
  { path: "/patients", component: PatientManagement },
  { path: "/add-family", component: AddFamily },
  { path: "/update-family/:value", component: UpdateFamily },
  { path: "/checkup-history/:value", component: CheckupHistory },
  { path: "/upcoming-schedule/:value", component: UpcomingSchedule },
  { path: "/detail-patient/:value", component: DetailPatient },
  { path: "/change-patient-data/:value", component: ChangePatientData },
  { path: "/add-member/:value", component: AddFamilyMember },
  { path: "/notifications", component: Notifications },
  { path: "/blocked-dates", component: BlockedDates },
  { path: "/add-date", component: AddDate },
  { path: "/update-date/:value", component: UpdateDate },

  { path: "/queue-praktek", component: QueueManagement },
  { path: "/queue-practicing-doctor", component: PracticingDoctor },
  { path: "/queue-consult", component: QueueConsultOnline },
  { path: "/queue-online-consultation", component: OnlineConsultation },

  { path: "/queue", component: MakeQueue },
  { path: "/create-queue-online", component: MakeQueueConsult },

  { path: "/detail-queue/:value", component: DetailQueue },
  { path: "/detail-queue-online/:value", component: DetailQueueConsult },

  { path: "/users", component: UserManagement },
  { path: "/add-user", component: AddUser },
  { path: "/update-user/:value", component: UpdateUser },

  { path: "/qrcode", component: QrCode },

  { path: "/vaccination-schedule", component: VaccinationSchedule },
  { path: "/set-schedule", component: SetSchedule },
  { path: "/update-vaccination-schedule/:value", component: UpdateVaccinationSchedule },
  { path: "/queuese/:value", component: Queues },
  { path: "/queues/:id", component: Queue },
  { path: "/queues-online/:value", component: QueuesConsult },
  { path: "/queues-front/:value", component: QueueFrontPage },
  { path: "/queues-front-online/:value", component: QueueFrontPageConsult },
  { path: "/active-queue/:value/:shiftId", component: DetailActiveQueue },
  { path: "/active-queue-consult/:value/:shiftId", component: DetailActiveQueueConsult },
  { path: "/add-queue/:value", component: AddQueue },

  // Terms and Condition
  { path: "/terms-and-conditions", component: TermsConditions },
  { path: "/update-terms/:value", component: EditTerms },
  // Bank Accounts
  { path: "/bank-accounts", component: BankAccounts },
  { path: "/add-bank-account", component: AddBankAccount },
  { path: "/update-bank-account/:value", component: EditBankAccount },

  // VISIT
  { path: "/visits", component: Visits },
  { path: "/visit", component: CreateVisit },
  { path: "/update-visit/:value", component: UpdateVisit },

  // VACCINES
  { path: "/vaccines", component: VaccinList },
  { path: "/add-vaccine", component: AddVaccine },
  { path: "/edit-vaccine/:value", component: EditVaccine },

  // VACCINE TYPES
  { path: "/vaccine-types", component: VaccineTypes },
  { path: "/add-vaccine-type", component: AddVaccineType },
  { path: "/add-vaccine-type-v2", component: AddEditVaccineType },
  { path: "/edit-vaccine-type/:value", component: AddEditVaccineType },

  { path: "/shifts", component: OpenSchedule },
  { path: "/add-shift", component: AddShift },
  { path: "/update-shift/:value", component: UpdateSchedule },

  { path: "/otp-login-pasien", component: OtpLoginPasien },

  // NOTIFICATION
  { path: "/context", component: Context },
  { path: "/broadcast", component: Broadcast },

  { path: "/configuration", component: Configuration },

  { path: "/request-certificate", component: RequestCertificate },
  { path: "/detail-request-certificate/:id", component: DetailRequestCertificate },
  { path: "/duplicate-data", component: DuplicateData },
];

const ADMIN_PATHS = ADMIN_ROUTES.map((route) => route.path);

class App extends React.Component {
  componentDidMount() {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }

  handleExpToken = () => {
    let token = localStorage.getItem("access_token");
    let base64UrlToken = token.split(".")[1];
    let decodedValueToken = JSON.parse(window.atob(base64UrlToken));
    if (
      decodedValueToken.exp < new Date().getTime() / 1000 ||
      localStorage.getItem("access_token") === null
    ) {
      console.log("token expired");
      // this.props.history.push("/login");
      localStorage.clear();
      window.location.reload();
    } else {
      console.log("token not expired");
    }
  };
  render() {
    if (
      localStorage.getItem("access_token") === null ||
      localStorage.getItem("access_token") === "undefined"
    ) {
      localStorage.clear();
      this.props.history.push("/login");
    } else {
      this.handleExpToken();
    }
    return (
      <div className="App" id="page-wrap" width="75%">
        <SimpleReactLightbox>
          <BrowserRouter>
            {/* <AdminRoute path="/login" component={LoginPage} /> */}
            <Route
              path="/reset-password/token=:token"
              component={ResetPassword}
            />
            {/* ADMIN COMPONENTS - one persistent AdminLayout (sidebar stays
                mounted) wrapping a Switch of all admin pages, instead of each
                page remounting its own AdminLayout+Sider on every navigation. */}
            <Route
              path={ADMIN_PATHS}
              render={() => (
                <AdminLayout>
                  <Switch>
                    {ADMIN_ROUTES.map(({ path, component }) => (
                      <Route key={path} path={path} component={component} />
                    ))}
                  </Switch>
                </AdminLayout>
              )}
            />

            <Route path="/show-queues/:value" component={ShowQueue} />

            {/* SUSTER COMPONENTS */}
            <Route path="/checkup" component={Checkup} />
            <Route path="/patient-detail" component={PatientDetail} />
            <Route path="/patient-measure" component={PatientMeasure} />

            <Route path="/vaccination" component={Vaccination} />
            <Route path="/edit-vaccination" component={EditVaccinationData} />

            <Route path="/patient-note" component={PatientNote} />
            <Route
              // path="/patient-visit/:queue/:child/:visit"
              path="/patient-visit"
              component={PatientVisit}
            />
            <Route
              path="/update-patient-visit"
              component={UpdatePatientVisit}
            />

            <Route path="/schedules/:queue/:value" component={FrontPage} />

            <Route
              path="/add-upcoming-vaccination/:child"
              component={AddUpcomingVaccination}
            />
            <Route
              path="/edit-upcoming-vaccination/:queueId/:childId"
              component={EditUpcomingVaccination}
            />
            <Route
              path="/add-upcoming-visit/:child"
              component={AddUpcomingVisit}
            />

            <Route path="/running-queue" component={RunningQueue} />
            <Route path="/self-checkin" component={SelfCheckin} />
          </BrowserRouter>
        </SimpleReactLightbox>
      </div>
    );
  }
}

export default App;
